module.exports = __webpack_public_path__ + "static/media/green3.55c31b82.png";